import styles from "./pageSkeleton.module.css";

/** Content-shaped loading placeholder used while a screen's code downloads. */
const PageSkeleton = ({ label = "Loading page" }) => (
  <div className={styles.skeleton} role="status" aria-live="polite" aria-busy="true">
    <span className={styles.srOnly}>{label}…</span>
    <div className={styles.header} aria-hidden="true">
      <span className={`${styles.block} ${styles.title}`} />
      <span className={`${styles.block} ${styles.action}`} />
    </div>
    <div className={styles.stats} aria-hidden="true">
      {[0, 1, 2, 3].map((item) => (
        <span key={item} className={`${styles.block} ${styles.stat}`} />
      ))}
    </div>
    <div className={styles.list} aria-hidden="true">
      {[0, 1, 2, 3, 4].map((item) => (
        <div key={item} className={styles.row}>
          <span className={`${styles.block} ${styles.avatar}`} />
          <span className={styles.lines}>
            <span className={`${styles.block} ${styles.line}`} />
            <span className={`${styles.block} ${styles.lineShort}`} />
          </span>
        </div>
      ))}
    </div>
  </div>
);

export default PageSkeleton;
